import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';
import logoArrows from '../images/logo_arrows.svg'; // Adjust the path as needed
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  const [isNative, setIsNative] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsNative(Capacitor.isNativePlatform());
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        padding: '20px',
        maxWidth: '800px',
        margin: '0 auto',
        position: 'relative',
      }}
    >
      {/* Back Button for Native Platforms */}
      {isNative && (
        <div
          style={{
            position: 'absolute',
            top: 20,
            left: 20,
            zIndex: 1000,
            cursor: 'pointer',
          }}
          onClick={handleGoBack}
          title="Go Back"
        >
          <ArrowLeft size={28} />
        </div>
      )}
      
      {/* Logo at the top center */}
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <img src={logoArrows} alt="EasySubs Logo" style={{ maxWidth: '200px', height: 'auto' }} />
      </div>

      <h1>Privacy Policy</h1>
      <p><strong>Data di efficacia:</strong> 27 ottobre 2025</p>
      <p><strong>Ultimo aggiornamento:</strong> 17 febbraio 2026</p>
      <p><strong>Nome Azienda:</strong> Easysubs</p>
      <p><strong>Email di contatto:</strong> info@easysubs.it</p>

      {/* Note about English version */}
      <p style={{ 
        textAlign: 'center', 
        fontSize: '14px', 
        fontStyle: 'italic',
        marginBottom: '30px',
        color: '#666'
      }}>
        The English version of this policy follows below / La versione inglese di questa policy segue sotto
      </p>

      {/* Italian Version */}
      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '10px' }}>
          🇮🇹 Versione Italiana
        </h2>

        <p>Questa informativa illustra come EasySubs ("App", "Servizio", "noi") raccoglie e tratta i dati personali degli utenti, ai sensi del Regolamento (UE) 2016/679 ("GDPR") e della normativa nazionale applicabile (incluso il D.lgs. 196/2003 come modificato).</p>
        <p>Questa informativa si applica all'applicazione mobile, ai siti web e alle proprietà digitali di EasySubs (collettivamente, "Piattaforma"). Puoi stampare questo documento tramite il comando di stampa del tuo browser.</p>

        <h3>1. TIPOLOGIA DI DATI TRATTATI</h3>
        <p>A seconda di come usi l'App e delle funzionalità attivate, potremmo trattare le seguenti categorie di dati:</p>
        <ul>
          <li><strong>Dati identificativi e di contatto:</strong> nome, cognome, email, nonché nome della società e partita IVA (solo in caso di registrazione aziendale).</li>
          <li><strong>Paese di residenza/preferenza:</strong> raccolto per fornire piani di abbonamento specifici per paese, informazioni su prezzi e disponibilità, e conversione nella valuta locale nel dashboard dell'utente.</li>
          <li><strong>Dati di account/identificativi tecnici:</strong> identificatori del dispositivo, token push, UUID, indirizzo IP, log applicativi, crash data/diagnostica.</li>
          <li><strong>Dati di utilizzo:</strong> eventi in-app, interazioni con funzionalità, informazioni su performance e stabilità.</li>
          <li><strong>Dati relativi agli abbonamenti gestiti dall'utente:</strong> nome servizio, piano, costo, scadenze.</li>
          <li><strong>Dati particolari (art. 9 GDPR):</strong> EasySubs non richiede né intende trattare categorie particolari di dati (salute, biometria a fini identificativi, opinioni politiche, ecc.). L'eventuale uso di Face ID/Touch ID è solo per sblocco locale della App e non ci consente accesso al dato biometrico.</li>
        </ul>

        <h3>2. UTILIZZO DEI DATI</h3>
        <p>EasySubs raccoglie esclusivamente le informazioni strettamente necessarie per offrirti un'esperienza sicura, efficiente e personalizzata, con l'obiettivo di:</p>
        <ul>
          <li>migliorare costantemente le funzionalità e le prestazioni dell'app;</li>
          <li>rispondere ai commenti, alle richieste di supporto e alle segnalazioni inviate dagli utenti;</li>
          <li>proporre servizi complementari o alternativi in linea con le preferenze e le esigenze dell'utente;</li>
          <li>offrire assistenza finalizzata all'avvio di potenziali relazioni commerciali tra utenti e fornitori di servizi;</li>
          <li>visualizzare piani di abbonamento, prezzi e disponibilità rilevanti per il Paese selezionato dall'utente e convertire i costi nella valuta locale dell'utente;</li>
          <li>inviare aggiornamenti periodici sulle migliori condizioni di mercato relative ai prodotti di interesse.</li>
        </ul>

        <h3>3. TRATTAMENTO E MISURE DI SICUREZZA</h3>
        <p>Trattiamo i dati con misure tecniche e organizzative adeguate a garantirne riservatezza, integrità e disponibilità, tra cui:</p>
        <ul>
          <li>Cifratura delle comunicazioni tramite protocollo https</li>
          <li>Controlli di accesso basati su autenticazione mediante credenziali personali.</li>
          <li>Pseudonimizzazione/minimizzazione dei dati dove possibile.</li>
          <li>Logging e audit su accessi ai sistemi.</li>
          <li>Backup e disaster recovery.</li>
        </ul>

        <h3>4. FORNITORI RESPONSABILI DEL TRATTAMENTO</h3>
        <p>Condividiamo dati personali solo con fornitori che agiscono quali Responsabili ai sensi dell'art. 28 GDPR, in base a contratti (DPA) e istruzioni documentate. In base alle opzioni attivate, potremmo avvalerci di:</p>
        <ul>
          <li>Apple (App Store, iCloud/CloudKit, TestFlight, SKAdNetwork).</li>
          <li>Fornitori PSD2/Open Banking.</li>
          <li>App Store Connect (analytics).</li>
          <li>Hosting/Infrastructure/CDN/DNS (MongoDB).</li>
        </ul>
        <p>Alcuni fornitori potrebbero avere sedi o server fuori dallo SEE (es. USA). In tali casi adottiamo garanzie adeguate (artt. 44-49 GDPR), come Clausole Contrattuali Standard della Commissione UE, misure tecniche/organizzative supplementari e valutazioni di impatto trasferimenti.</p>

        <h3>5. DIRITTI DEGLI INTERESSATI</h3>
        <p>Hai diritto di:</p>
        <ul>
          <li>Accesso ai dati e copia (art. 15).</li>
          <li>Rettifica (art. 16) e cancellazione ("diritto all'oblio", art. 17) nei casi previsti.</li>
          <li>Revoca del consenso (art. 7.3) in qualsiasi momento.</li>
          <li>Reclamo al Garante (www.garanteprivacy.it).</li>
        </ul>
        <p>Per esercitare i diritti scrivi a info@easysubs.it. Risponderemo entro 30 giorni (prorogabili nei casi complessi).</p>

        <h3>6. PROFILAZIONE</h3>
        <p>In alcuni casi, i dati degli utenti possono essere raccolti ed elaborati in forma anonima e aggregata, al solo scopo di generare report statistici e analisi omogenee utili al miglioramento continuo dei servizi offerti. Questa attività rientra nella profilazione leggera, finalizzata esclusivamente a migliorare l'esperienza dell'utente.</p>

        <h3>7. COOKIE E TECNOLOGIE SIMILI</h3>
        <p>La nostra web app utilizza esclusivamente cookie tecnici e strumenti di archiviazione strettamente necessari al corretto funzionamento del Servizio. Questi cookie sono essenziali per abilitare funzionalità fondamentali come:</p>
        <ul>
          <li>il login e l'autenticazione dell'utente;</li>
          <li>il mantenimento della sessione in modo sicuro;</li>
          <li>la garanzia della sicurezza di base e del corretto funzionamento.</li>
        </ul>
        <p>Ad esempio, potremmo memorizzare token di autenticazione sicuri (come token di sessione o JWT) per riconoscere la sessione dell'utente dopo il login. Non utilizziamo cookie per finalità pubblicitarie, di marketing o di tracciamento comportamentale. Poiché questi cookie sono strettamente necessari al funzionamento del Servizio, non richiedono il consenso preventivo.</p>

        <h3>8. MINORI</h3>
        <p>Il Servizio non è destinato a minori di 13 anni. I minori secondo la legge applicabile possono usare l'App solo con l'assistenza di un genitore/tutore.</p>
        <p>Non raccogliamo consapevolmente dati di bambini sotto i 13 anni. Se ritieni che un minore ci abbia fornito dati, contattaci per la rimozione.</p>

        <h3>9. MODIFICHE ALLA PRESENTE INFORMATIVA E CONTATTI</h3>
        <p>Potremmo aggiornare questa Privacy Policy per ragioni legali/tecniche/operative. In caso di modifiche sostanziali, ne daremo notizia nell'App e sito e email, se necessario. Ti invitiamo a consultare periodicamente questa pagina.</p>
        <p>Per domande, richieste di esercizio diritti o chiarimenti su questa informativa: info@easysubs.it</p>
      </div>

      {/* English Version */}
      <div style={{ borderTop: '2px solid #333', paddingTop: '20px' }}>
        <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '10px' }}>
          🇬🇧 English Version
        </h2>

        <p>This policy explains how EasySubs ("App", "Service", "we") collects and processes user's personal data, in accordance with Regulation (EU) 2016/679 ("GDPR") and applicable national legislation (including Legislative Decree 196/2003 as amended).</p>
        <p>This policy applies to the EasySubs mobile application, websites, and digital properties (collectively, "Platform"). You can print this document using your browser's print command.</p>

        <h3>1. TYPES OF DATA PROCESSED</h3>
        <p>Depending on how you use the App and the features you activate, we may process the following categories of data:</p>
        <ul>
          <li><strong>Identification and contact data:</strong> name, surname, email, as well as company name and VAT number (only in case of business registration).</li>
          <li><strong>Country of residence/preference:</strong> collected to provide country-specific subscription plans, pricing information, and local currency conversion in the user dashboard.</li>
          <li><strong>Account/technical identification data:</strong> device identifiers, push tokens, UUID, IP address, application logs, crash data/diagnostics.</li>
          <li><strong>Usage data:</strong> in-app events, feature interactions, performance and stability information.</li>
          <li><strong>Data related to subscriptions managed by the user:</strong> service name, plan, cost, expiration dates.</li>
          <li><strong>Special categories of data (Article 9 GDPR):</strong> EasySubs does not require nor intend to process special categories of data (health, biometric data for identification purposes, political opinions, etc.). Any use of Face ID/Touch ID is only for local app unlocking and does not allow us access to biometric data.</li>
        </ul>

        <h3>2. USE OF DATA</h3>
        <p>EasySubs collects only the information strictly necessary to provide you with a secure, efficient, and personalized experience, with the aim of:</p>
        <ul>
          <li>Constantly improving the app's functionality and performance;</li>
          <li>Responding to comments, support requests, and reports sent by users;</li>
          <li>Proposing complementary or alternative services in line with user preferences and needs;</li>
          <li>Providing assistance aimed at initiating potential commercial relationships between users and service providers;</li>
          <li>Displaying subscription plans, pricing, and availability relevant to the user's selected country, and converting costs into the user's local currency;</li>
          <li>Sending periodic updates on the best market conditions for products of interest.</li>
        </ul>

        <h3>3. PROCESSING AND SECURITY MEASURES</h3>
        <p>We process data with appropriate technical and organizational measures to ensure its confidentiality, integrity, and availability, including:</p>
        <ul>
          <li>Encryption of communications via HTTPS protocol;</li>
          <li>Access controls based on authentication through personal credentials;</li>
          <li>Pseudonymization/minimization of data where possible;</li>
          <li>Logging and auditing of system access;</li>
          <li>Backup and disaster recovery procedures.</li>
        </ul>

        <h3>4. DATA PROCESSORS</h3>
        <p>We share personal data only with providers who act as Data Processors pursuant to Article 28 GDPR, based on contracts (DPA) and documented instructions. Depending on the options activated, we may use:</p>
        <ul>
          <li>Apple (App Store, iCloud/CloudKit, TestFlight, SKAdNetwork);</li>
          <li>PSD2/Open Banking providers;</li>
          <li>App Store Connect (analytics);</li>
          <li>Hosting/Infrastructure/CDN/DNS (MongoDB).</li>
        </ul>
        <p>Some providers may have locations or servers outside the EEA (e.g., USA). In such cases, we adopt adequate safeguards (Articles 44-49 GDPR), such as Standard Contractual Clauses of the European Commission, supplementary technical/organizational measures, and transfer impact assessments.</p>

        <h3>5. DATA SUBJECT RIGHTS</h3>
        <p>You have the right to:</p>
        <ul>
          <li>Access your data and obtain a copy (Article 15);</li>
          <li>Rectification (Article 16) and erasure ("right to be forgotten", Article 17) in the cases provided;</li>
          <li>Withdraw consent (Article 7.3) at any time;</li>
          <li>Lodge a complaint with the Garante (www.garanteprivacy.it).</li>
        </ul>
        <p>To exercise your rights, write to info@easysubs.it. We will respond within 30 days (extendable in complex cases).</p>

        <h3>6. PROFILING</h3>
        <p>In some cases, user data may be collected and processed in anonymous and aggregated form, solely for the purpose of generating statistical reports and homogeneous analysis useful for the continuous improvement of the services offered. This activity falls under light profiling, aimed exclusively at improving the user experience.</p>

        <h3>7. COOKIES AND SIMILAR TECHNOLOGIES</h3>
        <p>Our web app uses only strictly necessary cookies and technical storage tools required for the Service to work properly. These cookies are essential to enable core features such as:</p>
        <ul>
          <li>user login and authentication;</li>
          <li>keeping you securely signed in;</li>
          <li>ensuring basic security and correct operation.</li>
        </ul>
        <p>For example, we may store secure authentication tokens (such as session or JWT tokens) to recognize your session after login. We do not use cookies for advertising, marketing, or behavioral tracking purposes. Because these cookies are strictly necessary for the functioning of the Service, they do not require prior consent.</p>

        <h3>8. MINORS</h3>
        <p>The Service is not intended for minors under 13 years of age. Minors according to applicable law may use the App only with the assistance of a parent/guardian. We do not knowingly collect data from children under 13. If you believe a minor has provided us with data, contact us for removal.</p>

        <h3>9. CHANGES TO THIS POLICY AND CONTACTS</h3>
        <p>We may update this Privacy Policy for legal/technical/operational reasons. In case of substantial changes, we will notify you in the App and on our website, and by email if necessary. We invite you to periodically consult this page.</p>
        <p>For questions, requests to exercise rights, or clarifications about this policy: <a href="mailto:info@easysubs.it">info@easysubs.it</a></p>

        <p>By using EasySubs, you acknowledge that you have read, understood, and agreed to this Privacy Policy.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;